export default __webpack_public_path__ + "static/media/img-8.e099d7fd.png";